import React, { useState, useEffect, useContext, useRef } from "react";
import { useTheme } from "@material-ui/core/styles";
import { useHistory, useLocation } from "react-router-dom";
import {
  makeStyles,
  Paper,
  InputBase,
  Tabs,
  Tab,
  Badge,
  IconButton,
  Typography,
  Grid,
  Tooltip,
  Switch,
} from "@material-ui/core";
import {
  Group,
  MoveToInbox as MoveToInboxIcon,
  CheckBox as CheckBoxIcon,
  MessageSharp as MessageSharpIcon,
  AccessTime as ClockIcon,
  Search as SearchIcon,
  Add as AddIcon,
  TextRotateUp,
  TextRotationDown,
  AccountTree as FlowIcon,
  Markunread as MarkunreadIcon,
  Event as EventIcon,
} from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import ToggleButton from "@material-ui/lab/ToggleButton";

import { FilterAltOff, FilterAlt, PlaylistAddCheckOutlined } from "@mui/icons-material";

import NewTicketModal from "../NewTicketModal";
import TicketsList from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import { Can } from "../Can";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { TagsFilter } from "../TagsFilter";
import { UsersFilter } from "../UsersFilter";
import { StatusFilter } from "../StatusFilter";
import { WhatsappsFilter } from "../WhatsappsFilter";
import { Button, Snackbar } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";

import api from "../../services/api";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },

  tabsHeader: {
    minWidth: "auto",
    width: "auto",
    borderRadius: 8,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },

  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: theme.spacing(1),
  },

  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },

    [theme.breakpoints.down("md")]: {
      fontSize: "0.75rem",
      padding: theme.spacing(0.25, 0.5),
      marginRight: theme.spacing(0.25),
      marginLeft: theme.spacing(0.25),
    },

    // Específico para monitores de 11-13 polegadas
    '@media (max-width: 1366px)': {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },
  },

  tabPanelItem: {
    minWidth: "33%",
    fontSize: 11,
    marginLeft: 0,
    transition: "all 0.3s ease",
    fontWeight: 500,
    borderRadius: "8px",
    margin: "0 4px",
    opacity: 0.7,
    "&.Mui-selected": {
      opacity: 1,
      backgroundColor: theme.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.1)",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
    },
    "&:hover": {
      opacity: 1,
      backgroundColor: theme.mode === "light" ? "rgba(0, 0, 0, 0.03)" : "rgba(255, 255, 255, 0.05)",
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: "30%",
      fontSize: 9,
      padding: theme.spacing(0.5),
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: "28%",
      fontSize: 8,
    },
  },

  tabIndicator: {
    height: 3,
    bottom: 0,
    borderRadius: "3px 3px 0 0",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    transition: "all 0.3s ease",
  },
  tabsBadge: {
    top: "-8px",
    right: "50%",
    transform: "translate(50%, -100%)",
    whiteSpace: "nowrap",
    borderRadius: "12px",
    padding: "0 8px",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    color: theme.mode === "light" ? "#FFF" : theme.palette.primary.main,
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
    background: theme.palette.optionsBackground,
    borderRadius: 8,
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    padding: theme.spacing(0.5),
    paddingTop: theme.spacing(2),
    overflow: "visible",
  },
  ticketOptionsBoxRow: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    minWidth: 0,
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      flex: "1 1 auto",
      minWidth: 0,
      maxWidth: "100%",
      overflowX: "auto",
      overflowY: "hidden",
      WebkitOverflowScrolling: "touch",
      paddingBottom: 6,
      marginRight: 4,
    },
  },
  ticketOptionsButtonsRow: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    minWidth: 0,
    gap: 2,
    [theme.breakpoints.down("sm")]: {
      flexShrink: 0,
      minWidth: "min-content",
      paddingRight: 8,
    },
  },

  serachInputWrapper: {
    flex: 1,
    height: 40,
    background: theme.palette.total,
    display: "flex",
    borderRadius: 40,
    padding: 4,
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },

  searchIcon: {
    color: "grey",
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },

  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 30,
  },

  badge: {
    // right: "-10px",
  },

  flowCountBadge: {
    top: "-4px",
    right: "-4px",
    transform: "translate(0, 0)",
    minWidth: 18,
    height: 18,
    fontSize: "0.7rem",
    fontWeight: "bold",
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  customBadge: {
    right: "-12px",
    top: "-10px",
    transform: "translate(30%, -30%)",
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    borderRadius: "10px",
    padding: "0 6px",
    fontWeight: "bold",
    fontSize: "0.75rem",
    minWidth: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
  },
  
  modernTabs: {
    minHeight: 54,
    borderRadius: 8,
    backgroundColor: theme.mode === "light" ? "rgba(0, 0, 0, 0.02)" : "rgba(255, 255, 255, 0.02)",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    padding: "8px 4px 4px 4px", // Aumentamos o padding superior para dar espaço ao badge
    margin: "8px 0",
    transition: "all 0.3s ease",
    position: "relative",
  },

  show: {
    display: "block",
  },

  hide: {
    display: "none !important",
  },

  closeAllFab: {
    backgroundColor: "red",
    marginBottom: "4px",
    "&:hover": {
      backgroundColor: "darkred",
    },
  },

  speedDial: {
    position: "absolute",
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    "& .MuiFab-root": {
      width: "40px",
      height: "40px",
      marginTop: "4px",
    },
    "& .MuiFab-label": {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },

  snackbar: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8em",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1em",
    },
  },

  yesButton: {
    backgroundColor: "#FFF",
    color: "rgba(0, 100, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "darkGreen",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  noButton: {
    backgroundColor: "#FFF",
    color: "rgba(139, 0, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "darkRed",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  filterIcon: {
    marginRight: 6,
    alignSelf: "center",
    color: theme.mode === "light" ? "#0872b9" : "#FFF",
    cursor: "pointer",
  },
  button: {
    height: 30,
    width: 30,
    border: "2px solid",
    borderColor: "#aaa",
    borderRadius: 8,
    marginRight: 8,
    "&:hover": {
      borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  icon: {
    color: "#aaa",
    "&:hover": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  buttonOpen: {
    "& $icon": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  // Classe padronizada para todos os botões de ação
  standardButton: {
    height: 30,
    width: 30,
    border: "2px solid #aaa",
    borderRadius: 8,
    marginRight: 8,
    padding: 0,
    minWidth: 'auto',
    "&:hover": {
      borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
    [theme.breakpoints.down('sm')]: {
      height: 28,
      width: 28,
      marginRight: 6,
    },
    // Ajuste para monitores pequenos (11-13 polegadas)
    '@media (max-width: 1366px)': {
      height: 28,
      width: 28,
      marginRight: 6,
    },
  },
  activeButton: {
    borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    borderWidth: "3px",
  },
  standardIcon: {
    color: "#aaa",
    fontSize: 18,
    "&:hover": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  activeIcon: {
    color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
  },
  // Estilos para o container de filtros
  filtersContainer: {
    padding: theme.spacing(1.5),
    margin: theme.spacing(0.5, 1),
    borderRadius: 8,
    backgroundColor: theme.mode === "light" ? "rgba(0, 0, 0, 0.02)" : "rgba(255, 255, 255, 0.05)",
    border: `1px solid ${theme.mode === "light" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)"}`,
  },
  filtersHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
    borderBottom: `1px solid ${theme.mode === "light" ? "rgba(0, 0, 0, 0.08)" : "rgba(255, 255, 255, 0.08)"}`,
  },
  filtersTitle: {
    fontSize: "0.85rem",
    fontWeight: 600,
    color: theme.mode === "light" ? theme.palette.text.primary : "#FFF",
  },
  clearFiltersButton: {
    fontSize: "0.7rem",
    padding: "4px 10px",
    borderRadius: 20,
    backgroundColor: theme.palette.error.main,
    color: "#FFF",
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
    },
  },
  filtersGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: theme.spacing(1),
    "& .MuiBox-root": {
      padding: "0 !important",
    },
    "& .MuiAutocomplete-root": {
      "& .MuiOutlinedInput-root": {
        padding: "2px 4px !important",
        paddingRight: "28px !important",
        minHeight: 32,
      },
      "& .MuiInputBase-input": {
        padding: "4px 2px !important",
        fontSize: "0.7rem",
        "&::placeholder": {
          fontSize: "0.6rem",
          opacity: 1,
        },
      },
      "& .MuiAutocomplete-endAdornment": {
        right: "4px !important",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.mode === "light" ? "rgba(0, 0, 0, 0.15)" : "rgba(255, 255, 255, 0.2)",
      },
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: "1fr",
    },
  },
}));

const TicketsManagerTabs = () => {
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const [sortTickets, setSortTickets] = useState(false);
  const [sortOrderMode, setSortOrderMode] = useState("unreadFirst");

  const searchInputRef = useRef();
  const [searchOnMessages, setSearchOnMessages] = useState(false);

  const { user } = useContext(AuthContext);
  const { profile } = user;
  const { setSelectedQueuesMessage } = useContext(QueueSelectedContext);
  const { tabOpen, setTabOpen } = useContext(TicketsContext);

  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [groupingCount, setGroupingCount] = useState(0);
  const [flowCount, setFlowCount] = useState(0);

  const userQueueIds = user.queues.map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [forceSearch, setForceSearch] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filter, setFilter] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isHoveredAll, setIsHoveredAll] = useState(false);
  const [isHoveredNew, setIsHoveredNew] = useState(false);
  const [isHoveredResolve, setIsHoveredResolve] = useState(false);
  const [isHoveredOpen, setIsHoveredOpen] = useState(false);
  const [isHoveredClosed, setIsHoveredClosed] = useState(false);
  const [isHoveredFlow, setIsHoveredFlow] = useState(false);
  const [isHoveredSort, setIsHoveredSort] = useState(false);

  const [isFilterActive, setIsFilterActive] = useState(false);
  const [filterKey, setFilterKey] = useState(0); // Key para forçar reset dos filtros

  // Função para limpar todos os filtros
  const handleClearFilters = () => {
    setSelectedTags([]);
    setSelectedUsers([]);
    setSelectedWhatsapp([]);
    setSelectedStatus([]);
    setFilterKey(prevKey => prevKey + 1); // Força recriação dos componentes de filtro
  };

  useEffect(() => {
    setSelectedQueuesMessage(selectedQueueIds);
  }, [selectedQueueIds, setSelectedQueuesMessage]);

  useEffect(() => {
    if (user.profile.toUpperCase() === "ADMIN" || user.allUserChat.toUpperCase() === "ENABLED") {
      setShowAllTickets(false);
    }
    
    // Verificar se há parâmetro 'tab' na URL ao carregar
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab');
    if (tabParam && ["pending", "open", "group", "closed", "flow"].includes(tabParam)) {
      // Definir a tab principal primeiro
      if (tabParam === "pending") {
        setTab("open"); // "Aguardando" está dentro da tab "open"
      } else if (tabParam === "open") {
        setTab("open");
      } else if (tabParam === "closed") {
        setTab("closed");
      } else if (tabParam === "group") {
        setTab("open"); // "Grupos" está dentro da tab "open"
      } else if (tabParam === "flow") {
        setTab("open");
      }
      // Depois definir a sub-aba (tabOpen)
      setTimeout(() => {
        setTabOpen(tabParam);
      }, 50);
    }
  }, [setTabOpen, user.allUserChat, user.profile]);

  // Monitorar mudanças na URL para atualizar a aba quando necessário
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams.get('tab');
    if (tabParam && ["pending", "open", "group", "closed", "flow"].includes(tabParam)) {
      // Se o parâmetro tab mudou, atualizar a aba
      if (tabOpen !== tabParam) {
        // Definir a tab principal primeiro
        if (tabParam === "pending") {
          setTab("open"); // "Aguardando" está dentro da tab "open"
        } else if (tabParam === "open") {
          setTab("open");
        } else if (tabParam === "closed") {
          setTab("closed");
        } else if (tabParam === "group") {
          setTab("open"); // "Grupos" está dentro da tab "open"
        } else if (tabParam === "flow") {
          setTab("open");
        }
        // Depois definir a sub-aba (tabOpen) com um pequeno delay
        setTimeout(() => {
          setTabOpen(tabParam);
        }, 100);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
    setForceSearch((prev) => !prev);
  }, [tab]);

  let searchTimeout;

  const handleSearch = (e) => {
    const searchedTerm = e.target.value.toLowerCase();

    clearTimeout(searchTimeout);

    if (searchedTerm === "") {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
      setTab("open");
      return;
    } else if (tab !== "search") {
      handleFilter();
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSearchParam(searchedTerm);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleBack = () => {
    history.push("/tickets");
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    handleBack();
    setTabOpen(newValue);
  };

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  const handleSnackbarOpen = () => {
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const CloseAllTicket = async () => {
    try {
      await api.post("/tickets/closeAll", {
        status: tabOpen,
        selectedQueueIds,
      });
      handleSnackbarClose();
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    console.log('[TAGS] handleSelectedTags chamado com:', selecteds);
    const tags = selecteds ? selecteds.map((t) => t.id) : [];
    console.log('[TAGS] IDs extraídos:', tags);

    clearTimeout(searchTimeout);

    // ✅ CORREÇÃO: Sempre atualizar o estado das tags imediatamente
    setSelectedTags(tags);

    if (tags.length === 0) {
      // Se não há tags, não precisa mudar para search
      setForceSearch(!forceSearch);
    } else {
      // Se há tags selecionadas, mudar para tab search para aplicar o filtro
      if (tab !== "search") {
        setTab("search");
      }
      // Atualizar forceSearch para forçar nova busca
      setForceSearch(!forceSearch);
    }
  };

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (users.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeout = setTimeout(() => {
      setSelectedUsers(users);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedWhatsapps = (selecteds) => {
    const whatsapp = selecteds.map((t) => t.id);

    clearTimeout(searchTimeout);

    if (whatsapp.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeout = setTimeout(() => {
      setSelectedWhatsapp(whatsapp);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleSelectedStatus = (selecteds) => {
    const statusFilter = selecteds.map((t) => t.status);

    clearTimeout(searchTimeout);

    if (statusFilter.length === 0) {
      setForceSearch(!forceSearch);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeout = setTimeout(() => {
      setSelectedStatus(statusFilter);
      setForceSearch(!forceSearch);
    }, 500);
  };

  const handleFilter = () => {
    if (filter) {
      setFilter(false);
      setTab("open");
      setSearchParam("");
      setSelectedTags([]);
      setSelectedUsers([]);
      setSelectedWhatsapp([]);
      setSelectedStatus([]);
      setForceSearch(!forceSearch);
      if (searchInputRef.current) {
        searchInputRef.current.value = "";
      }
    } else {
      setFilter(true);
      setTab("search");
    }
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <div className={classes.serachInputWrapper}>
        <SearchIcon className={classes.searchIcon} />
        <InputBase
          className={classes.searchInput}
          inputRef={searchInputRef}
          placeholder={i18n.t("tickets.search.placeholder")}
          type="search"
          onChange={handleSearch}
        />
        <Tooltip placement="top" title="Marque para pesquisar também nos conteúdos das mensagens (mais lento)">
          <div>
            <Switch
              size="small"
              checked={searchOnMessages}
              onChange={(e) => { setSearchOnMessages(e.target.checked) }}
            />
          </div>
        </Tooltip>
        <IconButton
          style={{
            backgroundColor: "transparent",
            boxShadow: "none",
            border: "none",
            borderRadius: "50%",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
          variant="contained"
          aria-label="filter"
          className={classes.filterIcon}
          onClick={() => {
            setIsFilterActive((prevState) => !prevState);
            handleFilter();
          }}
        >
          {isFilterActive ? (
            <FilterAlt className={classes.icon} />
          ) : (
            <FilterAltOff className={classes.icon} />
          )}
        </IconButton>
      </div>

      {filter === true && (
        <div className={classes.filtersContainer}>
          <div className={classes.filtersHeader}>
            <Typography className={classes.filtersTitle}>
              {i18n.t("tickets.search.filtersApplied") || "Filtros Aplicados"}
            </Typography>
            <Button
              className={classes.clearFiltersButton}
              size="small"
              onClick={handleClearFilters}
            >
              ⊗ {i18n.t("tickets.search.clearFilters") || "Limpar Filtros"}
            </Button>
          </div>
          <div className={classes.filtersGrid} key={filterKey}>
            <TagsFilter onFiltered={handleSelectedTags} />
            <WhatsappsFilter onFiltered={handleSelectedWhatsapps} />
            <StatusFilter onFiltered={handleSelectedStatus} />
            <UsersFilter onFiltered={handleSelectedUsers} />
          </div>
        </div>
      )}

      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <Grid container alignItems="center" wrap="nowrap" style={{ minWidth: 0, width: "100%" }}>
          <Grid item className={classes.ticketOptionsBoxRow}>
            <div className={classes.ticketOptionsButtonsRow}>
            <Can
              role={user.allUserChat === 'enabled' && user.profile === 'user' ? 'admin' : user.profile}
              perform="tickets-manager:showall"
              yes={() => (
<Badge
  color="primary"
  invisible={
    !isHoveredAll ||
    isHoveredNew ||
    isHoveredResolve ||
    isHoveredOpen ||
    isHoveredClosed
  }
  badgeContent={"Todos"}
  classes={{ badge: classes.tabsBadge }}
>
  <ToggleButton
    onMouseEnter={() => setIsHoveredAll(true)}
    onMouseLeave={() => setIsHoveredAll(false)}
    className={`${classes.standardButton} ${showAllTickets ? classes.activeButton : ''}`}
    value="uncheck"
    selected={showAllTickets}
    onChange={() => setShowAllTickets((prevState) => !prevState)}
  >
    {showAllTickets ? (
      <VisibilityIcon className={`${classes.standardIcon} ${classes.activeIcon}`} />
    ) : (
      <VisibilityOffIcon className={classes.standardIcon} />
    )}
  </ToggleButton>
</Badge>
              )}
            />
            <Snackbar
              open={snackbarOpen}
              onClose={handleSnackbarClose}
              message={i18n.t("tickets.inbox.closedAllTickets")}
              ContentProps={{
                className: classes.snackbar,
              }}
              action={
                <>
                  <Button
                    className={classes.yesButton}
                    size="small"
                    onClick={CloseAllTicket}
                  >
                    {i18n.t("tickets.inbox.yes")}
                  </Button>
                  <Button
                    className={classes.noButton}
                    size="small"
                    onClick={handleSnackbarClose}
                  >
                    {i18n.t("tickets.inbox.no")}
                  </Button>
                </>
              }
            />
<Badge
  color="primary"
  invisible={
    isHoveredAll ||
    !isHoveredNew ||
    isHoveredResolve ||
    isHoveredOpen ||
    isHoveredClosed
  }
  badgeContent={i18n.t("tickets.inbox.newTicket")}
  classes={{ badge: classes.tabsBadge }}
>
  <IconButton
    onMouseEnter={() => setIsHoveredNew(true)}
    onMouseLeave={() => setIsHoveredNew(false)}
    className={classes.standardButton}
    onClick={() => {
      setNewTicketModalOpen(true);
    }}
  >
    <AddIcon className={classes.standardIcon} />
  </IconButton>
</Badge>
{user.profile === "admin" && (
  <Badge
    color="primary"
    invisible={
      isHoveredAll ||
      isHoveredNew ||
      !isHoveredResolve ||
      isHoveredOpen ||
      isHoveredClosed
    }
    badgeContent={i18n.t("tickets.inbox.closedAll")}
    classes={{ badge: classes.tabsBadge }}
  >
    <IconButton
      onMouseEnter={() => setIsHoveredResolve(true)}
      onMouseLeave={() => setIsHoveredResolve(false)}
      className={classes.standardButton}
      onClick={handleSnackbarOpen}
    >
      <PlaylistAddCheckOutlined className={classes.standardIcon} />
    </IconButton>
  </Badge>
)}
{/* Botão "Abertos" */}
<Badge
  invisible={
    !(
      tab === "open" &&
      !isHoveredAll &&
      !isHoveredNew &&
      !isHoveredResolve &&
      !isHoveredClosed &&
      !isHoveredFlow &&
      !isHoveredSort
    ) && !isHoveredOpen
  }
  badgeContent={i18n.t("tickets.inbox.open")}
  classes={{ badge: classes.tabsBadge }}
>
  <IconButton
    onMouseEnter={() => {
      setIsHoveredOpen(true);
    }}
    onMouseLeave={() => {
      setIsHoveredOpen(false);
    }}
    className={`${classes.standardButton} ${
      (tab === "open" || isHoveredOpen) ? classes.activeButton : ''
    }`}
    onClick={() => handleChangeTab(null, "open")}
  >
    <MoveToInboxIcon
      className={`${classes.standardIcon} ${
        (tab === "open" || isHoveredOpen) ? classes.activeIcon : ''
      }`}
    />
  </IconButton>
</Badge>

{/* Botão "Resolvidos" */}
<Badge
  color="primary"
  invisible={
    !(
      tab === "closed" &&
      !isHoveredAll &&
      !isHoveredNew &&
      !isHoveredResolve &&
      !isHoveredOpen &&
      !isHoveredFlow &&
      !isHoveredSort
    ) && !isHoveredClosed
  }
  badgeContent={i18n.t("tickets.inbox.resolverd")}
  classes={{ badge: classes.tabsBadge }}
>
  <IconButton
    onMouseEnter={() => {
      setIsHoveredClosed(true);
    }}
    onMouseLeave={() => {
      setIsHoveredClosed(false);
    }}
    className={`${classes.standardButton} ${
      (tab === "closed" || isHoveredClosed) ? classes.activeButton : ''
    }`}
    onClick={() => handleChangeTab(null, "closed")}
  >
    <CheckBoxIcon
      className={`${classes.standardIcon} ${
        (tab === "closed" || isHoveredClosed) ? classes.activeIcon : ''
      }`}
    />
  </IconButton>
</Badge>

{/* Botão "Flow" - tickets em execução de fluxo; balão com contagem quando houver tickets */}
<Tooltip title={i18n.t("ticketsList.flowHeader") || "Flow"} placement="bottom">
  <Badge
    color="primary"
    overlap="circular"
    invisible={flowCount === 0}
    badgeContent={flowCount}
    classes={{ badge: classes.flowCountBadge }}
  >
    <IconButton
      onMouseEnter={() => setIsHoveredFlow(true)}
      onMouseLeave={() => setIsHoveredFlow(false)}
      className={`${classes.standardButton} ${
        (tab === "open" && tabOpen === "flow") || isHoveredFlow ? classes.activeButton : ''
      }`}
      onClick={() => {
        handleChangeTab(null, "open");
        handleChangeTabOpen(null, "flow");
      }}
    >
      <FlowIcon
        className={`${classes.standardIcon} ${
          (tab === "open" && tabOpen === "flow") || isHoveredFlow ? classes.activeIcon : ''
        }`}
      />
    </IconButton>
  </Badge>
</Tooltip>

{tab !== "closed" && tab !== "search" && (
  <Badge
    color="primary"
    invisible={
      !isHoveredSort ||
      isHoveredAll ||
      isHoveredNew ||
      isHoveredResolve ||
      isHoveredOpen ||
      isHoveredClosed
    }
    badgeContent={!sortTickets ? "Crescente" : "Decrescente"}
    classes={{ badge: classes.tabsBadge }}
  >
    <ToggleButton
      onMouseEnter={() => setIsHoveredSort(true)}
      onMouseLeave={() => setIsHoveredSort(false)}
      className={`${classes.standardButton} ${sortTickets ? classes.activeButton : ''}`}
      value="uncheck"
      selected={sortTickets}
      onChange={() => setSortTickets((prevState) => !prevState)}
    >
      {!sortTickets ? (
        <TextRotateUp className={`${classes.standardIcon} ${sortTickets ? classes.activeIcon : ''}`} />
      ) : (
        <TextRotationDown className={`${classes.standardIcon} ${classes.activeIcon}`} />
      )}
    </ToggleButton>
  </Badge>
)}
{/* Não lidos primeiro / Por data - mesmo conjunto de botões */}
<Tooltip title={i18n.t("ticketsList.sortUnreadFirst")} placement="bottom">
  <IconButton
    size="small"
    className={`${classes.standardButton} ${sortOrderMode === "unreadFirst" ? classes.activeButton : ""}`}
    onClick={() => setSortOrderMode("unreadFirst")}
  >
    <MarkunreadIcon className={`${classes.standardIcon} ${sortOrderMode === "unreadFirst" ? classes.activeIcon : ""}`} />
  </IconButton>
</Tooltip>
<Tooltip title={i18n.t("ticketsList.sortByDate")} placement="bottom">
  <IconButton
    size="small"
    className={`${classes.standardButton} ${sortOrderMode === "byDate" ? classes.activeButton : ""}`}
    onClick={() => setSortOrderMode("byDate")}
  >
    <EventIcon className={`${classes.standardIcon} ${sortOrderMode === "byDate" ? classes.activeIcon : ""}`} />
  </IconButton>
</Tooltip>
            </div>
          </Grid>
<Grid item style={{ minWidth: 0, flex: "0 1 auto", maxWidth: 150, marginLeft: 8, marginRight: 28 }}>
<span className="MuiBadge-root" style={{ display: "block", minWidth: 0 }}>
  <TicketsQueueSelect
    selectedQueueIds={selectedQueueIds}
    userQueues={user?.queues}
    onChange={(values) => setSelectedQueueIds(values)}
  />
</span>
</Grid>
        </Grid>
      </Paper>

      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          scrollButtons="auto"
          TabIndicatorProps={{ className: classes.tabIndicator }}
          className={classes.modernTabs}
        >
          {/* ATENDENDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center" style={{ position: "relative", paddingTop: 10 }}>
                <Grid item>
                  <Badge
                    overlap="circular"
                    max={999}
                    classes={{ badge: classes.customBadge }}
                    badgeContent={openCount}
                    color="primary"
                  >
                    <MessageSharpIcon
                      style={{
                        fontSize: 20,
                        color: tabOpen === "open" ? theme.palette.primary.main : "inherit",
                      }}
                    />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 11,
                      fontWeight: tabOpen === "open" ? 700 : 500,
                      color: tabOpen === "open" ? theme.palette.primary.main : "inherit",
                      transition: "all 0.2s ease",
                    }}
                  >
                    {i18n.t("ticketsList.assignedHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"open"}
            name="open"
            classes={{ root: classes.tabPanelItem }}
          />

          {/* AGUARDANDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center" style={{ position: "relative", paddingTop: 10 }}>
                <Grid item>
                  <Badge
                    overlap="circular"
                    max={999}
                    classes={{ badge: classes.customBadge }}
                    badgeContent={pendingCount}
                    color="primary"
                  >
                    <ClockIcon
                      style={{
                        fontSize: 20,
                        color: tabOpen === "pending" ? theme.palette.primary.main : "inherit",
                      }}
                    />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 11,
                      fontWeight: tabOpen === "pending" ? 700 : 500,
                      color: tabOpen === "pending" ? theme.palette.primary.main : "inherit",
                      transition: "all 0.2s ease",
                    }}
                  >
                    {i18n.t("ticketsList.pendingHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"pending"}
            name="pending"
            classes={{ root: classes.tabPanelItem }}
          />

          {/* GRUPOS */}
          {user.allowGroup && (
            <Tab
              label={
                <Grid container alignItems="center" justifyContent="center" style={{ position: "relative", paddingTop: 10 }}>
                  <Grid item>
                    <Badge
                      overlap="circular"
                      max={999}
                      classes={{ badge: classes.customBadge }}
                      badgeContent={groupingCount}
                      color="primary"
                    >
                      <Group
                        style={{
                          fontSize: 20,
                          color: tabOpen === "group" ? theme.palette.primary.main : "inherit",
                        }}
                      />
                    </Badge>
                  </Grid>
                  <Grid item>
                    <Typography
                      style={{
                        marginLeft: 8,
                        fontSize: 11,
                        fontWeight: tabOpen === "group" ? 700 : 500,
                        color: tabOpen === "group" ? theme.palette.primary.main : "inherit",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {i18n.t("ticketsList.groupingHeader")}
                    </Typography>
                  </Grid>
                </Grid>
              }
              value={"group"}
              name="group"
              classes={{ root: classes.tabPanelItem }}
            />
          )}

        </Tabs>

        <Paper className={classes.ticketsWrapper}>
          <TicketsList
            status="open"
            showAll={showAllTickets}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            sortOrderMode={sortOrderMode}
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setOpenCount(val)}
            style={applyPanelStyle("open")}
            setTabOpen={setTabOpen}
          />
          <TicketsList
            status="pending"
            selectedQueueIds={selectedQueueIds}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            sortOrderMode={sortOrderMode}
            showAll={user.profile === "admin" || user.allUserChat === 'enabled' ? showAllTickets : false}
            updateCount={(val) => setPendingCount(val)}
            style={applyPanelStyle("pending")}
            setTabOpen={setTabOpen}
          />
          {user.allowGroup && (
            <TicketsList
              status="group"
              showAll={showAllTickets}
              sortTickets={sortTickets ? "ASC" : "DESC"}
              sortOrderMode={sortOrderMode}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setGroupingCount(val)}
              style={applyPanelStyle("group")}
              setTabOpen={setTabOpen}
            />
          )}
          <TicketsList
            status="flow"
            showAll={showAllTickets}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            sortOrderMode={sortOrderMode}
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setFlowCount(val)}
            style={applyPanelStyle("flow")}
            setTabOpen={setTabOpen}
          />
        </Paper>
      </TabPanel>

      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsList
          status="closed"
          showAll={showAllTickets}
          sortTickets={sortTickets ? "ASC" : "DESC"}
          sortOrderMode={sortOrderMode}
          selectedQueueIds={selectedQueueIds}
          setTabOpen={setTabOpen}
        />
      </TabPanel>

      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        {profile === "admin" && (
          <>
            <TicketsList
              statusFilter={selectedStatus}
              searchParam={searchParam}
              showAll={showAllTickets}
              sortTickets={sortTickets ? "ASC" : "DESC"}
              sortOrderMode={sortOrderMode}
              tags={selectedTags}
              users={selectedUsers}
              selectedQueueIds={selectedQueueIds}
              whatsappIds={selectedWhatsapp}
              forceSearch={forceSearch}
              searchOnMessages={searchOnMessages}
              status="search"
            />
          </>
        )}

        {profile === "user" && (
          <TicketsList
            statusFilter={selectedStatus}
            searchParam={searchParam}
            showAll={false}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            sortOrderMode={sortOrderMode}
            tags={selectedTags}
            selectedQueueIds={selectedQueueIds}
            whatsappIds={selectedWhatsapp}
            forceSearch={forceSearch}
            searchOnMessages={searchOnMessages}
            status="search"
          />
        )}
      </TabPanel>
    </Paper >
  );
};

export default TicketsManagerTabs;